module.exports = __webpack_public_path__ + "img/people.59e24b5c.svg";